// Carry Roll default request factory — driver sample defaults.
import { degToRad } from '../engine/units';
import { ClubCategory, DistanceMode, Fidelity, Firmness, InputMode, LandingSurface, SurfaceMoisture, } from '../engine/types';
export const DEFAULT_DRIVER_REQUEST = {
    launch: {
        ballSpeed: 75, // ~167 mph
        launchAngle: degToRad(14.1),
        spinRpm: 2700,
        clubSpeed: 45,
        spinAxisDeg: 0,
        launchDirDeg: 0,
        apexHint: null,
    },
    delivery: null,
    environment: {
        altitudeM: 0,
        temperatureK: 293.15,
        windSpeed: 0,
        windDirDeg: 0,
        firmness: Firmness.Normal,
        moisture: SurfaceMoisture.Normal,
        landingSurface: LandingSurface.Fairway,
        landingSlopeDeg: 0,
        crossSlopeDeg: 0,
        elevationDiffM: 0,
        seaLevelBaseline: false,
        humidity: 0.5,
        pressurePa: 101325,
    },
    override: { landingAngleDeg: null },
    club: {
        category: ClubCategory.Driver,
        loftDeg: 10.5,
        rollPercent: 0.18,
    },
    fidelity: Fidelity.Full,
    ballType: 'tour',
};
export { ClubCategory, DistanceMode, Fidelity, Firmness, InputMode, LandingSurface, SurfaceMoisture };
//# sourceMappingURL=defaultRequest.js.map